import CredentialManagementView from 'app/views/credential_management_view';
import BaseModal from 'app/views/modals/base_modal';

import { showSuccess, showResponseError } from 'utils/messages';

import tmpl from 'templates/create_carrier_account_modal';

export default BaseModal.extend({
  compiledTemplate: tmpl,

  events: {
    'click .cancel': 'close',
    'click .create_account': 'createAccount',
  },

  initialize() {
    const fields = this.model.get('fields');
    if (fields.credentials) {
      this.manageCredentials = true;
      this.addSubview('credentialManagement', '#credential_management', new CredentialManagementView({
        model: this.model,
        key: 'credentials',
      }));
    }

    if (fields.test_credentials) {
      this.manageTestCredentials = true;
      this.addSubview('testCredentialManagement', '#test_credential_management', new CredentialManagementView({
        model: this.model,
        key: 'test_credentials',
      }));
    }

    if (fields.auto_link) {
      this.autoLink = true;
    }
  },

  context() {
    return {
      readable: this.model.get('readable'),
      hasCredentials: this.manageCredentials,
      hasTestCredentials: this.manageTestCredentials,
      autoLink: this.autoLink,
    };
  },

  createAccount(event) {
    event.preventDefault();
    const description = this.$('input#carrier_account_description').val();
    const reference = this.$('input#carrier_account_reference').val();
    const attributes = {
      type: this.model.get('type'),
      description: description || undefined,
      reference: reference || undefined,
    };
    if (this.manageCredentials) {
      attributes.credentials = this.getSubview('credentialManagement').getFullData();
    }

    if (this.manageTestCredentials) {
      attributes.test_credentials = this.getSubview('testCredentialManagement').getFullData();
    }

    this.collection.create(attributes, {
      wait: true,
      success() {
        showSuccess('Your carrier account was successfully created');
      },
      error(model, response) {
        showResponseError(response);
      },
    });

    this.close();
  },
});



// WEBPACK FOOTER //
// ./app/views/modals/create_carrier_account_modal.js